import React from 'react';
import { useSelector } from 'react-redux';
import { Typography, Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import { getAlternateLogo, xssSanitize } from "../../../utils";
import { getThemes } from '../../../reducers/portalConfig';

import { SchemeShape } from '../constants';
import { useLogin } from "../context";
import { getThemeDetails } from "../utils";

const AuthSchemeListItem = ({ scheme, classes }) => {
  const { referrer, setSelectedAuthScheme, setProvider, clearGlobalErrors } = useLogin();
  const themeData = useSelector(getThemes);
  const { logo: portalLogo, siteTitle } = getThemeDetails(themeData);

  const logo = scheme.logo ? scheme.logo : portalLogo;
  let name, description;
  if (scheme.showFyp) {
    name = siteTitle;
    description = '';
  } else {
    name = scheme.name;
    description = scheme.description;
  }
  const alternateLogo = getAlternateLogo(name);

  const handleAuthSchemeClick = () => {
    clearGlobalErrors();
    setProvider(scheme.uuid);
    if (scheme.credsReqd) {
      setSelectedAuthScheme(scheme);
    } else {
      let redirectPath = '';
      if (scheme.authMethod === 'SAML_DEPRECATED' && referrer) {
        redirectPath = "?fromUrl=" + xssSanitize(referrer);
      }
      window.location.href = scheme.url + redirectPath;
    }
  }

  return (
    <Button
      id={scheme.uuid}
      data-apim-test="login-authscheme-button"
      variant="outlined" color='secondary'
      classes={{
        root: classes.buttonStyles, startIcon: logo ? classes.buttonIcon : '',
      }}
      startIcon={logo ? <img
        alt="Portal Logo"
        src={logo}
      /> : <Typography className={classes.alternateLogo} align='center'>
        {alternateLogo}
      </Typography>}
      onClick={handleAuthSchemeClick}
    >
      <Typography className={classes.buttonContent} color='inherit' component='div'>
        {name}
        {description && <Typography variant='body2'>
          {description}
        </Typography>}
      </Typography>
    </Button>
  )
}

AuthSchemeListItem.propTypes = {
  scheme: PropTypes.shape(SchemeShape),
  classes: PropTypes.shape(),
}

export default AuthSchemeListItem;
